module.exports = __webpack_public_path__ + "img/arrow-up-right.ae00b7a1.svg";